import { computeRSquared, computeSSE } from '../utils/math';
import { filterDiscoveryCounts } from '../series/discoverySeries';

export const computeIncrementalMetrics = (observedCounts, expectedCounts) => {
  if (!observedCounts || !expectedCounts || observedCounts.length !== expectedCounts.length) return null;
  const observed = observedCounts.map(item => item.count);
  const expected = expectedCounts.map(item => item.count);
  return {
    sse: computeSSE(observed, expected),
    rSquared: computeRSquared(observed, expected),
  };
};

export const computeExpectedCurveCounts = (curveFn, params, discoveryCounts, modelStartYear) => {
  if (!curveFn || !params || !Number.isFinite(modelStartYear)) return null;
  const filtered = filterDiscoveryCounts(discoveryCounts, modelStartYear);
  if (!filtered.length) return null;
  const expected = [];
  let previous = 0;
  for (let i = 0; i < filtered.length; i += 1) {
    const year = filtered[i].year;
    const t = year - modelStartYear;
    const cumulative = curveFn(params, t);
    if (!Number.isFinite(cumulative)) return null;
    const count = Math.max(0, cumulative - previous);
    expected.push({ year, count });
    previous = cumulative;
  }
  return expected;
};
